import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button } from '@xsolla/ui-core';
import { ArrowLeft } from '@xsolla/ui-icons';

import { usePaths } from '../../../routes/routesHelper';
import Mailchimp from '../Mailchimp';
import { BoldWrapper, UsersHeaderWrapper } from './style';

const UsersListHeader = ({ history }: RouteComponentProps): JSX.Element => {
  const { dashboardPath } = usePaths();
  const intl = useIntl();
  const backToDashboard = () => history.push({ pathname: dashboardPath() });

  return (
    <UsersHeaderWrapper>
      <Button look="link" palette="muted" onClick={backToDashboard}>
        <ArrowLeft />
        <span>
          {intl.formatMessage(
            { id: 'create-login-page.back' },
            {
              b: (chunk: string) => <BoldWrapper>{chunk}</BoldWrapper>
            }
          )}
        </span>
      </Button>

      <Mailchimp />
    </UsersHeaderWrapper>
  );
};

export default withRouter(UsersListHeader);
